var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atlas-root"},[(_vm.$route.name === 'solarSystem')?_c('AtlasSystem'):_c('div',{staticClass:"notification is-light"},[_vm._v("\n    Раздел в разработке.\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }